import { postJwtRegister } from "../../../helpers/backend_helper";
import { registerUserFailed, registerUserSuccessful, resetRegisterFlagChange } from "./reducer";

export const registerUser = (user : any) => async (dispatch : any) => {
  try {
    const response: any = await postJwtRegister('/post-jwt-register', user);

    if (response) {
       dispatch(registerUserSuccessful(response));
    } else {
       dispatch(registerUserFailed(response));
    }
  } catch (error : any) {
    dispatch(registerUserFailed(error));
  }
};

export const resetRegisterFlag = () => {
  try {
    return resetRegisterFlagChange();
  } catch (error) {
    return error;
  }
};
